import React, {FC, useState} from "react"
import styled from "styled-components"

import Markdown from "@irati/ui/src/Markdown"

import {Hr} from "@irati/ui/src/Layout"
import {Deal} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import GenericModal from "@irati/ui/src/GenericModal"
import tracking from "@irati-tracking/perks/perks"
import {H3} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"

interface Props {
  id?: string
  deal: Deal
}

const StyledModal = styled(GenericModal)`
  z-index: 1050;
`

const TermsAndConditions: FC<Props> = ({deal}) => {
  const {termsAndConditions} = deal
  if (!termsAndConditions) {
    return null
  }

  const [isModalOpen, showModal] = useState(false)

  const openModal = () => {
    tracking.viewTerms(deal)
    showModal(true)
  }

  return (
    <>
      <Hr />
      <Flex justifyContent="center" marginBottom={1.5}>
        <Button cta onClick={openModal}>
          <FormattedMessage id="perks.components.importantInfoBlock.importantInfoBlock.tAndC" />
        </Button>
      </Flex>
      <StyledModal
        backdropStyle={{zIndex: 1050}}
        show={isModalOpen}
        onHide={() => showModal(false)}
        actions={
          <Flex justifyContent="flex-end" marginTop={3}>
            <Button primary onClick={() => showModal(false)}>
              <FormattedMessage id="perks.components.simpleModal.close" />
            </Button>
          </Flex>
        }>
        <Spacing marginBottom={3}>
          <H3>
            <FormattedMessage id="perks.components.importantInfoBlock.importantInfoBlock.tAndC" />
          </H3>
        </Spacing>
        <Markdown source={termsAndConditions} />
      </StyledModal>
    </>
  )
}

export default TermsAndConditions
